import { render } from "./newsIcon.vue?vue&type=template&id=32641af0"
import script from "./newsIcon.vue?vue&type=script&lang=js"
export * from "./newsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__